import { trans } from '@pepita-i18n/babelfish';
import gtxConstants from '@getrix/common/js/gtx-constants';

export const RegisterSuccessBox = () => {
    return (
        <div className="form-account-message">
            <h1 className="gx-title">
                {trans('label.register_at2', {
                    APP_NAME: gtxConstants('APP_NAME'),
                })}
            </h1>
            <div className="gx-alert gx-alert--margin gx-alert--success">
                <svg className="gx-icon gx-icon--positive">
                    <use
                        xlinkHref={`${window.gtxConstants.ICONS_SVG_SPRITE_FILE_PATH}#check-circle`}
                    ></use>
                </svg>
                <span>{trans('register.success.title')}</span>
            </div>

            <div className="register-text">
                <p
                    dangerouslySetInnerHTML={{
                        __html: trans('register.success.text', {
                            TEL_SERVIZIO_CLIENTI:
                                window.gtxConstants.TEL_SERVIZIO_CLIENTI,
                        }),
                    }}
                ></p>
            </div>
        </div>
    );
};
